import { IconProps } from './IconProps';

export function PersonalNoteIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                id="Notes-Add--Streamline-Streamline--3.0.svg"
                clipPath="url(#clip0_19_25744)"
            >
                <path
                    id="Vector"
                    d="M9.47656 20.4849H1.47656C1.21135 20.4849 0.956992 20.3795 0.769456 20.192C0.581919 20.0044 0.476563 19.7501 0.476562 19.4849V3.48486C0.476563 3.21965 0.581919 2.96529 0.769456 2.77776C0.956992 2.59022 1.21135 2.48486 1.47656 2.48486H15.4766C15.7418 2.48486 15.9961 2.59022 16.1837 2.77776C16.3712 2.96529 16.4766 3.21965 16.4766 3.48486V8.48486"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_2"
                    d="M4.47656 4.48486V0.484863"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_3"
                    d="M8.47656 4.48486V0.484863"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_4"
                    d="M12.4766 4.48486V0.484863"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_5"
                    d="M11.4766 17.4849C11.4766 18.2728 11.6318 19.053 11.9333 19.781C12.2348 20.5089 12.6768 21.1704 13.2339 21.7275C13.7911 22.2847 14.4525 22.7266 15.1805 23.0281C15.9084 23.3297 16.6886 23.4849 17.4766 23.4849C18.2645 23.4849 19.0447 23.3297 19.7727 23.0281C20.5006 22.7266 21.1621 22.2847 21.7192 21.7275C22.2764 21.1704 22.7183 20.5089 23.0198 19.781C23.3214 19.053 23.4766 18.2728 23.4766 17.4849C23.4766 16.6969 23.3214 15.9167 23.0198 15.1888C22.7183 14.4608 22.2764 13.7994 21.7192 13.2422C21.1621 12.6851 20.5006 12.2431 19.7727 11.9416C19.0447 11.6401 18.2645 11.4849 17.4766 11.4849C16.6886 11.4849 15.9084 11.6401 15.1805 11.9416C14.4525 12.2431 13.7911 12.6851 13.2339 13.2422C12.6768 13.7994 12.2348 14.4608 11.9333 15.1888C11.6318 15.9167 11.4766 16.6969 11.4766 17.4849Z"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_6"
                    d="M17.4766 14.4849V20.4849"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_7"
                    d="M20.4766 17.4849H14.4766"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_19_25744">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
